export enum ERouteName {
  LOGIN = "login",
  DASHBOARD = "dashboard",
  SITE_SEARCH = "site-search",
  SITE_CREATE = "site-create",
  SITE_DETAILS = "site-details",
  SITE_DETAILS_OVERVIEW = "site-details-overview",
  SITE_DETAILS_GALLERY = "site-details-gallery",
  SITE_DETAILS_DOCUMENTS = "site-details-documents",
  SITE_DETAILS_SUPPORT = "site-details-support",
  SITE_DETAILS_CONSUMPTION = "site-details-consumption",
  SITE_DETAILS_ROTATION = "site-details-rotation",
  SITE_DETAILS_LIVE_VX = "site-details-live-vx",
  SITE_DETAILS_DTD = "site-details-dtd",
  SITE_DETAILS_OPERATION = "site-details-operation",
  SITE_DETAILS_WORKING_CONDITION_MODULATIONS = "site-details-working-condition-modulations",
  SITE_DETAILS_WORKING_CONDITION_ACQUISITION = "site-details-working-condition-acquisition",
  SITE_DETAILS_SUBSCRIBER_FEEDBACK = "site-details-subscriber-feedback",
  SITE_DETAILS_SENSORS = "site-details-sensors",
  SITE_DETAILS_SUBSCRIBER_EDIT = "site-details-subscriber-edit",
  SITE_DETAILS_SITE_EDIT = "site-details-site-edit",
  SITE_DETAILS_APPOINTMENT = "site-details-appointment",
  SITE_DETAILS_DELIVERY_POINT = "site-details-delivery-point",
  SITE_DETAILS_CLOSE_CALL = "site-details-close-call",
  SITE_DETAILS_ATTACH_SUBSCRIBER = "site-details-attach-subscriber",
  SITE_DETAILS_COMFORT = "site-details-comfort",
  SITE_DETAILS_OFFERS_ELIGIBILITY = "site-details-offers-eligibility",
  SITE_DETAILS_ELIGIBILITY_FORM = "site-details-eligibility-form",
  SITE_DETAILS_ESC_FODLER = "site-details-esc-folder",
  V4H_SITES_SEARCH = "v4h-sites-search",
  V4H_ORGANIZATION_DETAILS = "v4h-organization-details",
  V4H_ORGANIZATION_OVERVIEW = "v4h-organization-overview",
  V4H_ORGANIZATION_SUPPORT = "v4h-organization-support",
  V4H_ORGANIZATION_PILOT_OVERSIGHT = "v4h-organization-pilot-oversight",
}
